//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "setting",
  props: {
    userinfo: undefined
  }, data: () => ({
    update_loading: false,
    email_disabled: true,
    user: {},
    valid: true,
    name: '',
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    select: null,
    items: [
      'Item 1',
      'Item 2',
      'Item 3',
      'Item 4',
    ],
    checkbox: false,
  }),
  created() {
    this.user = {
      'email':this.$store.state.user.userinfo.email
    };
    this.user = Object.assign(this.user,this.$store.state.user.userinfo.userinfo)
    if (!this.user.telegram) {
      this.user.telegram = {};
    }
  },
  methods: {
    validate() {
      this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    update_userinfo: function () {
      var post_data = this.user;
      post_data['action'] = 'update';

      this.update_loading = true;

      this.$axios.post('/app/user/info', post_data).then((response) => {
        console.log("response:",response);
        this.update_loading = false;
        this.$messageX("更新成功");
      }).catch((error) => {
        this.update_loading = false;
      });

    }
  },
}
